export var PushMessageTypes;
(function (PushMessageTypes) {
    PushMessageTypes["Odds"] = "OddsMessage";
    PushMessageTypes["Sogei"] = "SogeiID";
    PushMessageTypes["UserBets"] = "UserBets";
})(PushMessageTypes || (PushMessageTypes = {}));
//# sourceMappingURL=PushMessageTypes.js.map